
<div class="wrapLayout">

  <button class="plusminus" (blur)="setValue()" (click)="handleMinus(numericData)"> - </button>

  <!--<input value={{numericData}} (blur)="setValue(numericData)" type="number" class="num" />-->
  <input [(ngModel)]="numericData" (blur)="setValue()" type="number" class="num" />

  <button class="plusminus" (blur)="setValue()" (click)="handlePlus(numericData)"> + </button>
  <button kendoButton *ngIf="isUpdateButton && visibleUpdateButton" [primary]="true" title="update" (click)="setValueOnUpdateClick()" style="padding:0px !important;">
    <span class="k-icon k-i-save"></span> 
  </button>
</div>

